import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';
import { AgreementTemplate, AgreementTemplateVersion } from './admin/agreementTemplates';


export type StateExhibitTemplate = {
  template: AgreementTemplate;
  version: AgreementTemplateVersion;
};


export type StateExhibitSigned = {
  id: string;
  agreementTemplateId: string;
  content: string;
  licenseId: string;
  signedAt: string;
  expireAt: string;
  createdAt: string;
  archived: { by: string; at: string } | null;
};


export type StateExhibitExpiring = {
  agreementTemplateId: string;
  licenseId: string;
  expireAt: string;
};


export type StateExhibitExpired = {
  agreementTemplateId: string;
  licenseId: string;
  expiredAt: string;
};


export type SignStateExhibitParams = {
  templateId: string;
  version: number;
};


export type RenewStateExhibitParams = {
  templateId: string;
  version: number;
};


export const getStateExhibitTemplate = (providerId: string, licenseId: string) =>
  restClient.request<{ data: StateExhibitTemplate }>(
    `/api/v1/provider/${providerId}/license/${licenseId}/state_exhibit/template`
  );


export const signStateExhibit = (providerId: string, licenseId: string, params: SignStateExhibitParams) =>
  restClient.request<{ data: StateExhibitSigned }>(
    `/api/v1/provider/${providerId}/license/${licenseId}/state_exhibit/sign`,
    { method: 'POST', data: snakecaseKeys(params) }
  );


export const renewStateExhibit = (providerId: string, licenseId: string, params: RenewStateExhibitParams) =>
  restClient.request<{ data: StateExhibitSigned }>(
    `/api/v1/provider/${providerId}/license/${licenseId}/state_exhibit/renew`,
    { method: 'POST', data: snakecaseKeys(params) }
  );


export const getProviderExhibitSignatures = (providerId: string) =>
  restClient.request<{ data: StateExhibitSigned[] }>(
    `/api/v1/provider/${providerId}/state_exhibit_signatures`
  );


export const archiveStateExhibit = (licenseId: string) =>
  restClient.request<{ data: StateExhibitSigned }>(
    `/api/v1/provider/license/${licenseId}/state_exhibit/archive`,
    { method: 'PATCH' }
  );


export const downloadStateExhibit = (stateExhibitId: string) =>
  restClient.fileRequest<Blob>(`/api/v1/state_exhibit/${stateExhibitId}/download`, {
    method: 'POST',
    responseType: 'blob',
  });
